import BiBaseDataItem from '../common/bi-base-item';

export const APP_LOAD_FINISH_EVID = 11;

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
export default class BiLoadFinishDataItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(APP_LOAD_FINISH_EVID, sessionId);
  }
}
